import React from 'react';
import {
  Box,
  Button,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowBack, Edit as EditIcon, SupportAgent as SupportAgentIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import type { Cliente } from '../../../../services/clienteService';
import { labelTipoCliente } from '../../../../config/tipoClienteOptions';
import { ROUTES } from '../../../../config/routes';

interface Props {
  cliente: Cliente;
  onVolver: () => void;
  onEditarMaestro: () => void;
}

const Info360Header: React.FC<Props> = ({ cliente, onVolver, onEditarMaestro }) => {
  const navigate = useNavigate();
  const nombre =
    (cliente.razonSocial || cliente.nombre || '').trim() || `Cliente #${cliente.nroCliente}`;
  const estadoLabel = labelTipoCliente(cliente.tipoCliente);
  const vendedor = cliente.vendedorInfo?.nombreVendedor?.trim()
    || (cliente.vendedor != null ? `Vendedor #${cliente.vendedor}` : 'Sin vendedor');

  return (
    <Stack spacing={1.5}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', sm: 'flex-start' }}
      >
        <Box>
          <Button
            startIcon={<ArrowBack />}
            onClick={onVolver}
            sx={{ textTransform: 'none', mb: 0.5, px: 0, minWidth: 0 }}
            aria-label="Volver"
          >
            Volver
          </Button>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: '#1976d2' }}>
            Info 360
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 600, mt: 0.5 }}>
            {nombre}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            #{cliente.nroCliente}
            {cliente.cuit ? ` · CUIT ${cliente.cuit}` : ''}
          </Typography>
        </Box>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ alignSelf: { xs: 'stretch', sm: 'flex-start' } }}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<SupportAgentIcon />}
            onClick={() => navigate(ROUTES.ventas.clientes.gestion({ nroCliente: cliente.nroCliente }))}
            sx={{ textTransform: 'none' }}
          >
            Gestión
          </Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<EditIcon />}
            onClick={onEditarMaestro}
            sx={{ textTransform: 'none' }}
          >
            Editar maestro
          </Button>
        </Stack>
      </Stack>

      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        <Chip
          size="small"
          label={estadoLabel}
          color={cliente.tipoCliente?.toUpperCase() === 'I' ? 'default' : 'success'}
          variant="outlined"
        />
        {cliente.condVta ? (
          <Chip size="small" label={`Cond. venta: ${cliente.condVta}`} variant="outlined" />
        ) : null}
        <Chip size="small" label={vendedor} variant="outlined" />
        {cliente.listaPrecio?.descripcion || cliente.nroLista ? (
          <Chip
            size="small"
            label={`Lista: ${cliente.listaPrecio?.descripcion || cliente.nroLista}`}
            variant="outlined"
          />
        ) : null}
      </Stack>
    </Stack>
  );
};

export default Info360Header;
